/**
 * 跳转小程序
 * @param {Function} fallback 跳转失败/桌面端时的回调（显示小程序码）
 */
export function jumpToMiniApp(fallback) {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

  if (isMobile) {
    // 手机端 → URL Scheme 拉起微信小程序
    window.location.href = 'weixin://dl/business/?t=1w8rSM1Xylb'

    // 10秒后没跳走 → 显示小程序码
    const timer = setTimeout(() => fallback?.(), 10000)

    // 页面隐藏说明微信已打开，清理定时器
    const handler = () => {
      if (document.hidden) {
        clearTimeout(timer)
        document.removeEventListener('visibilitychange', handler)
      }
    }
    document.addEventListener('visibilitychange', handler)
  } else {
    // 桌面端 → 直接显示小程序码
    fallback?.()
  }
}
